module.exports = __webpack_public_path__ + "img/logo-vnm-01.23a72e4d.png";